import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import PrivateRoute from './PrivateRoute'

import Homepage from './Homepage'
import Header from './Components/focus2022/Header';
import TechnicalSessions from './Components/focus2022/Attendee/TechnicalSessions';

import NotFound from './Components/focus2022/NotFound';

import WorkProgress from './Components/focus2022/WorkProgress';
import Login from './Components/focus2022/Login';
import LoginSingleSignOn from './Components/focus2022/LoginSingleSignOn';
import Register from './Components/focus2022/Register';

import AboutSession from './Components/focus2022/Attendee/AboutSession';
import ResetPassword from './Components/focus2022/ResetPassword';
import DashboardSpeaker from './Components/focus2022/Speaker/Dashboard';
import ProfileDetails from './Components/focus2022/Speaker/ProfileDetails';

import ExhibitorDetails from './Components/focus2022/Exhibitor/ExhibitorDetails';
import ExhibitorBooth from './Components/focus2022/Exhibitor/ExhibitorBooth';

import Dashboard from './Components/focus2022/Exhibitor/Dashboard';
import LoginSplash from './Components/focus2022/LoginSplash';
import SingleSignOn from './Components/focus2022/SingleSignOn';

import Lobby from './Components/focus2022/Attendee/Lobby';
import ExhibitHall from './Components/focus2022/Attendee/ExhibitHall';
import NetworkingLounge from './Components/focus2022/Attendee/NetworkingLounge';
import ConferenceCenter from './Components/focus2022/Attendee/ConferenceCenter';
import ConferenceCenterPage from './Components/focus2022/Attendee/ConferenceCenterPage';
import TrackConferenceDetail from './Components/focus2022/Attendee/TrackConferenceDetail';
import ExhibitList from './Components/focus2022/Attendee/ExhibitList';
import Session from './Components/focus2022/Attendee/Session';

import HelpDesk from './Components/focus2022/Attendee/HelpDesk';
import GoldenTicket from './Components/focus2022/Attendee/GoldenTicket';
import AttendeeExhibitorBooth from './Components/focus2022/Attendee/AttendeeExhibitorBooth';

import UserProfile from './Components/focus2022/UserProfile';

import ChatPage from "./TmChat/focus2022/chat/ChatPage";
import VideoCall from "./TmChat/focus2022/video/VideoCall";
import ConferenceMeeting from "./TmChat/focus2022/videoConference/conferenceMeeting";
import Meetings from "./TmChat/focus2022/videoConference/meetings";
/* import test from './Components/focus2022/Exhibitor/test'; */

class Focus2022 extends Component {
constructor(){
  super();

  this.state={
    homePage:""
  }
}
componentDidMount(){
  //console.log(window.location.href)
  
}

  render() {

    const domain = window.location.href
    if(domain === ("http://localhost:3000/" || "https://affectionate-bohr-4d306b.netlify.app/")){
      return(
        <div className="App">
            <Router>
              <Route path="/" exact component={Homepage} />
              {/* <Route path="/home" exact component={Homepage} /> */}
            </Router>
        </div>
      )
    }
    else {
      return (
      <Router>
          <div className="App">
            
            <Header/>
            <Switch>
                
                <Route path="/focus2022/sessionList" component={TechnicalSessions} />
                <Route path="/focus2022/login/:loginId" component={Login} />
                <Route path="/focus2022/loginSingleSignOn/:loginId" component={LoginSingleSignOn} />
                <Route path="/focus2022/resetPassword" component={ResetPassword} />
                <Route path="/focus2022/register" component={Register} />
                <Route path="/focus2022/single-signon/:eventId/:emailId/:tokenpass" exact component={SingleSignOn} />
                <Route path="/focus2022/attendee/aboutsession/:sessionId" component={AboutSession} />
                <Route path="/focus2022/workProgress" exact component={WorkProgress} />
                <PrivateRoute path="/focus2022/loginSplash" exact component={LoginSplash} />
                <PrivateRoute path="/focus2022/speaker/dashboard" exact component={DashboardSpeaker} />
                <PrivateRoute path="/focus2022/speaker/profile" exact component={ProfileDetails} />
                <PrivateRoute path="/focus2022/exhibitor/dashboard" exact component={Dashboard} />
                <PrivateRoute path="/focus2022/exhibitor/profile" exact component={ExhibitorDetails} />
                <PrivateRoute path="/focus2022/exhibitor/booth" component={ExhibitorBooth} />

                <PrivateRoute path="/focus2022/chat" exact component={ChatPage} />
                <PrivateRoute path="/focus2022/video-call" exact component={VideoCall} />
                <PrivateRoute path="/focus2022/video-conference" exact component={Meetings} />
                <PrivateRoute path="/focus2022/conference-meeting/:id" exact component={ConferenceMeeting} />

                <PrivateRoute path="/focus2022/attendee/lobby" component={Lobby} />
                <PrivateRoute path="/focus2022/attendee/exhibitHall" component={ExhibitHall} />
                <PrivateRoute path="/focus2022/attendee/networkingLounge" component={NetworkingLounge} />
                <PrivateRoute path="/focus2022/attendee/conferenceCenter" component={ConferenceCenter} />
                <PrivateRoute path="/focus2022/attendee/session" component={Session} />
                <PrivateRoute path="/focus2022/attendee/conferenceCenterDetails/:sessionId" component={ConferenceCenterPage} />
                <PrivateRoute path="/focus2022/attendee/trackConferenceDetail/:trackId" component={TrackConferenceDetail} />
                <PrivateRoute path="/focus2022/attendee/technicalSessions" component={TechnicalSessions} />
                <PrivateRoute path="/focus2022/attendee/exhibitList" component={ExhibitList} />
                <PrivateRoute path="/focus2022/attendee/helpDesk" component={HelpDesk} />
                <PrivateRoute path="/focus2022/user/profile" exact component={UserProfile} />
                <PrivateRoute path="/focus2022/attendee/goldenTicket" component={GoldenTicket} />
                <PrivateRoute path="/focus2022/attendee/exhibitorBooth/:exhibitorId" component={AttendeeExhibitorBooth} />
                <Route path="*" component={NotFound} />
              </Switch>
         
          </div>
      </Router>
    );}
  }  
}

export default Focus2022;
